/**
 * Patenti di guida di Stati Uniti e Canada (standard AAMVA).
 *
 * Sul retro hanno un codice a barre PDF417 che contiene tutti i dati in
 * chiaro, un campo per riga con un codice di tre lettere davanti:
 * DCS cognome, DAC/DCT nome, DBB nascita, DBC sesso, DAQ numero patente,
 * DBA scadenza, DBD rilascio, DCG paese, DAJ stato.
 */

/** Data AAMVA: MMGGAAAA negli USA, AAAAMMGG in Canada. */
function data(s, paese) {
  const t = String(s || "").replace(/[^0-9]/g, "");
  if (t.length !== 8) {
    return null;
  }
  if (paese === "CAN" || (/^(19|20)/.test(t) && parseInt(t.substring(4, 6), 10) <= 12)) {
    return t.substring(0, 4) + "-" + t.substring(4, 6) + "-" + t.substring(6, 8);
  }
  return t.substring(4, 8) + "-" + t.substring(0, 2) + "-" + t.substring(2, 4);
}

/**
 * Legge il testo del PDF417 di una patente AAMVA.
 *
 * @returns {object|null} null se il testo non e' di una patente AAMVA
 */
export function leggiAamva(testo) {
  const t = String(testo || "");
  if (!/ANSI ?\d{6}|AAMVA/.test(t) || !/DAQ/.test(t)) {
    return null;
  }
  const campi = {};
  // I campi sono separati da a capo o dal separatore di record (codice 30).
  for (let riga of t.split(String.fromCharCode(30)).join("\n").split(/[\r\n]+/)) {
    // Il primo campo e' attaccato all'intestazione "ANSI ...DL0041...DL":
    // comincia dopo il "DL" che apre la sezione della patente.
    const intestazione = riga.match(/ANSI.*?\dDL(D[A-Z]{2}.*)$/);
    if (intestazione) {
      riga = intestazione[1];
    }
    const m = riga.trim().match(/^(D[A-Z]{2})(.*)$/);
    if (m && !campi[m[1]]) {
      campi[m[1]] = m[2].trim();
    }
  }
  const paese = campi.DCG || "USA";
  let nome = campi.DAC || campi.DCT || "";
  // Nelle versioni vecchie DCT contiene nome e secondo nome separati da virgola.
  nome = nome.replace(/,/g, " ").replace(/\s+/g, " ").trim();
  const sesso = campi.DBC === "1" || campi.DBC === "M" ? "M" : campi.DBC === "2" || campi.DBC === "F" ? "F" : "";
  return {
    cognome: campi.DCS || "",
    nome,
    sesso,
    dataNascita: data(campi.DBB, paese),
    numero: campi.DAQ || "",
    dataScadenza: data(campi.DBA, paese),
    dataRilascio: data(campi.DBD, paese),
    paese: paese === "CAN" ? "CAN" : "USA",
    stato: campi.DAJ || ""
  };
}

export default { leggiAamva };
